export default function useBuildTarget() {
  const { buildTarget } = useRuntimeConfig().public;

  const isProduction = buildTarget === 'production';

  return { isProduction };
}
